import graphAxios from "../utils/graph-axios";
import { getFbAccessToken, getUserId } from "../utils/helpers";

const get = (link) => {
  if (link) return graphAxios.get(link);
  const userId = getUserId();
  const fbAccessToken = getFbAccessToken();
  return graphAxios.get(`/${userId}/accounts`, {
    params: {
      access_token: fbAccessToken,
      fields: ["link", "name", "fan_count", "category"].join(","),
    },
  });
};

const getById = (id) => {
  const fbAccessToken = getFbAccessToken();

  return graphAxios.get(`/${id}`, {
    params: {
      access_token: fbAccessToken,
      fields: ["link", "name", "fan_count", "category", "access_token"].join(
        ",",
      ),
    },
  });
};

const getPosts = ({ pageId, link }) => {
  if (link) return graphAxios.get(link);
  const access_token = getFbAccessToken();

  return graphAxios.get(`/${pageId}/feed`, {
    params: {
      access_token,
      limit: 10,
      fields:
        "story,message,full_picture,permalink_url,created_time,attachments",
    },
  });
};

const FanpageAPI = {
  get,
  getById,
  getPosts,
};
export default FanpageAPI;
